import { render, staticRenderFns } from "./DeudasImputadasSimpleTable.vue?vue&type=template&id=540f5267&scoped=true"
import script from "./DeudasImputadasSimpleTable.vue?vue&type=script&lang=js"
export * from "./DeudasImputadasSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f5267",
  null
  
)

export default component.exports